
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'ProgressBar'
})
export default class ProgressBar extends Vue {
  @Prop({ default: 0, type: Number }) percent: number

  get formatedWidth(): number {
    let width = 0
    if (!isNaN(this.percent)) {
      width = this.percent
    }
    width = Math.min(100, width)
    width = Math.max(0, width)
    return width
  }
}
